import { useContext } from 'react';
import { ThemeContext } from '.';

function useTheme() {
  return useContext(ThemeContext);
}

export default useTheme;
